module.exports = __webpack_public_path__ + "img/sort-selected.6accda12.svg";